import { Apis } from '../../app.constants.js';
import APIService from '../../APIService.js';

type LoginActionType = {
  login: (credentials: { username: string; password: string }) => Promise<any>;
  userInformation: (userId: any) => Promise<any>;
  forgotPassword: (data: { email: string; link: string }) => Promise<any>;
  guestLogin: (data: {
    email: string;
    username: string;
    first_name: string;
    mobile: number;
    user_code: number;
  }) => Promise<any>;
  resetPassword: (data: { code: string; email: string; password: string }) => Promise<any>;
};

const LoginActions = (): LoginActionType => {
  const login = async (credentials: { username: string; password: string }) => {
    try {
      const response = await APIService.post(Apis.login, credentials);
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const otpLogin = async (data: { user_id: number; otp: string }) => {
    try {
      const response = await APIService.post(Apis.otpLogin, data);
      return response;
    } catch (error: any) {
      return {
        status: error?.response?.status,
        data: error?.response?.data,
      };
    }
  };

  const userInformation = async (userId: any) => {
    try {
      const response = await APIService.get(`${Apis.getUsersByOrganisation}${userId}/`);
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const forgotPassword = async (data: {
  username: string;
  email: string;
}) => {

  try {

    const response = await APIService.post(
      `${Apis.forgotPassword}`,
      data
    );

    return response;

  } catch (error) {

    console.error('Forgot password error:', error);
    throw error;
  }
};

  const guestLogin = async (data: {
    email: string;
    username: string;
    first_name: string;
    mobile: number;
  }) => {
    try {
      const response = await APIService.post(Apis.guestLogin, data);
      return response;
    } catch (error) {
      console.error('Guest login error:', error);
      throw error;
    }
  };

  const resetPassword = async (data: { code: string; email: string; password: string }) => {
    try {
      const response = await APIService.post(`${Apis.resetPassword}`, data);
      return response;
    } catch (error) {
      console.error('Reset password error:', error);
      throw error;
    }
  };
  return {
    login,
    otpLogin,
    userInformation,
    forgotPassword,
    guestLogin,
    resetPassword,
  };
};

export { LoginActions };
